const BACKEND = process.env.REACT_APP_DB_PATH;
export const API_optimize_schedule_breaks = BACKEND + "/api/store_info/optimize_schedule_breaks";
export const API_business_settings = BACKEND + "/api/company_info/business_settings";
export const API_role_colors = BACKEND + "/api/company_info/role_colors";
export const API_pay_period_settings = BACKEND + "/api/clock_info/pay_period_settings";


export const API_get_home_store = BACKEND + "/api/get_home_store?user=";
export const API_get_forecasted_sales_daily =
  BACKEND + "/api/forecasted_sales_daily?store_id=";
export const API_get_forecasted_transactions_daily =
  BACKEND + "/api/forecasted_transactions_daily?store_id=";
export const API_get_forecasted_other_daily =
  BACKEND + "/api/store_info/forecasted_other_daily?store_id=";

export const API_get_reservation_summary =
  BACKEND + "/api/reservation_info/get_reservation_summary_by_date_range?store_id=";

export const API_get_overview = BACKEND + "/api/store_info/get_overview";

export const API_get_adjustments_chosen =
  BACKEND + "/api/adjustments_chosen?store_id=";
export const API_get_adjustments_history =
  BACKEND + "/api/adjustments_history?store_id=";

export const API_get_forecasted_labor =
  BACKEND + "/api/forecasted_labor?store_id=";
// NOTE: Yes, we need to use the v2 API now that labor law stuff is turned on
export const API_get_actual_schedule =
  BACKEND + "/api/store_info/get_actual_schedule_v2?store_id=";
export const API_get_published_shift_count =
  BACKEND + "/api/published_shift_count?store_id=";

export const API_get_published_schedule_actions =
  BACKEND + "/api/store_info/get_published_schedule_actions?store_id=";

export const API_revert_published_schedule_action =
  BACKEND + "/api/store_info/revert_published_schedule_action";

export const API_get_actual_schedule_labor_deployment =
  BACKEND + "/api/actual_schedule_labor_deployment?store_id=";
export const API_get_actual_sales_daily =
  BACKEND + "/api/actual_sales_daily?store_id=";
export const API_get_actual_other_daily =
  BACKEND + "/api/store_info/actual_other_daily?store_id=";
export const API_get_calculated_earned_labor =
  BACKEND + "/api/calculated_earned_labor?store_id=";
export const API_get_actual_used_labor_vs_earned =
  BACKEND + "/api/actual_used_labor_vs_earned?store_id=";

export const API_load_schedule_from_template =
  BACKEND + "/api/load_schedule_from_template?store_id=";
export const API_save_schedule_as_template =
  BACKEND + "/api/save_schedule_as_template?store_id=";
export const API_load_prev_week_schedule =
  BACKEND + "/api/prev_week_schedule?store_id=";
export const API_load_employee_prev_week_schedule =
  BACKEND + "/api/store_info/load_employee_prev_week_schedule?store_id=";
export const API_get_store_team_members =
  BACKEND + "/api/store_team_members?store_id=";
export const API_get_store_team_member_weekly_info =
  BACKEND + "/api/store_info/get_store_team_member_weekly_info?store_id=";
export const API_get_pos_link_reconciliation =
  BACKEND + "/api/store_info/pos_link_reconciliation?store_id=";
export const API_post_pos_link_combine =
  BACKEND + "/api/store_info/pos_link_combine";

export const API_get_template_names = BACKEND + "/api/template_names?store_id=";
export const API_delete_schedule_template =
  BACKEND + "/api/delete_schedule_template?store_id=";

export const API_edit_shift = BACKEND + "/api/edit_shift?store_id=";

export const API_get_default_availability =
  BACKEND + "/api/schedule_info/get_default_availability?store_id=";
export const API_get_default_target_hours =
  BACKEND + "/api/default_target_hours?store_id=";
export const API_get_request_off = BACKEND + "/api/request_off?store_id=";
export const API_get_available_roles =
  BACKEND + "/api/available_roles?store_id=";

export const API_get_capable_roles = BACKEND + "/api/available_roles";

export const API_get_role_names = BACKEND + "/api/role_names?store_id=";
export const API_get_role_names2 = BACKEND + "/api/role_names";
export const API_get_station_info = BACKEND + "/api/station_info?store_id=";

export const API_get_departments = BACKEND + "/api/get_role_types";
export const API_get_roles = BACKEND + "/api/role_names";
export const API_get_stations = BACKEND + "/api/stations";

export const API_list_pos_roles = BACKEND + "/api/pos_info/list_pos_roles"
export const API_create_role_from_pos_role = BACKEND + "/api/pos_info/create_role_from_pos_role"
export const API_link_pos_role = BACKEND + "/api/pos_info/link_pos_role"
export const API_archive_pos_role = BACKEND + "/api/pos_info/archive_pos_role"
export const API_restore_pos_role = BACKEND + "/api/pos_info/restore_pos_role"
export const API_job_mappings = BACKEND + "/api/pos_info/job_mappings"
export const API_suggest_job_mappings = BACKEND + "/api/pos_info/suggest_job_mappings"
export const API_integrate_heartland_retail = BACKEND + "/api/pos_info/integrate_heartland_retail"
export const API_integrate_square = BACKEND + "/api/pos_info/integrate_square"
export const API_integrate_toast = BACKEND + "/api/pos_info/integrate_toast"

export const API_edit_availability =
  BACKEND + "/api/schedule_info/edit_availability?store_id=";

export const API_update_team_member_info =
  BACKEND + "/api/update_team_member_info?store_id=";

export const API_autoschedule_settings = BACKEND + "/api/autoschedule_settings?store_id=";
export const API_auto_schedule = BACKEND + "/api/auto_schedule?store_id=";

export const API_accept_auto_schedule =
  BACKEND + "/api/accept_auto_schedule?store_id=";

export const API_delete_all_shifts =
  BACKEND + "/api/delete_all_shifts?store_id=";
export const API_publish_schedule = BACKEND + "/api/publish_schedule?store_id=";

export const API_add_forecast_adjustment =
  BACKEND + "/api/add_forecast_adjustment?store_id=";
export const API_get_manual_intraday_distribution =
  BACKEND + "/api/get_manual_intraday_distribution?store_id=";
export const API_save_manual_intraday_distribution =
  BACKEND + "/api/save_manual_intraday_distribution?store_id=";
export const API_add_manual_actual_sales =
  BACKEND + "/api/add_manual_actual_sales?store_id=";
export const API_edit_multiple_shifts =
  BACKEND + "/api/edit_multiple_shifts?store_id=";

export const API_get_member_stores = BACKEND + "/api/member_stores?username=";
export const API_change_home_store =
  BACKEND + "/api/change_home_store?username=";

export const API_get_daily_operating_hours =
  BACKEND + "/api/get_daily_operating_hours?store_id=";
export const API_edit_operating_hours =
  BACKEND + "/api/edit_operating_hours?store_id=";

export const API_get_default_operating_hours =
  BACKEND + "/api/get_default_operating_hours?store_id=";

export const API_get_weather = BACKEND + "/api/get_weather?store_id=";
export const API_get_events = BACKEND + "/api/get_events?store_id=";
export const API_get_events_base = BACKEND + "/api/get_events";
export const API_get_holidays = BACKEND + "/api/get_holidays";
export const API_save_event = BACKEND + "/api/save_event";
export const API_update_event = BACKEND + "/api/update_event?event_id=";
export const API_delete_event = BACKEND + "/api/delete_event?event_id=";
export const API_attach_event_file = BACKEND + "/api/attach_event_file";
export const API_remove_event_file = BACKEND + "/api/remove_event_file";
export const API_get_forecast_exclude_dates =
  BACKEND + "/api/store_info/get_forecast_exclude_dates?store_id=";
export const API_save_forecast_exclude_date =
  BACKEND + "/api/store_info/save_forecast_exclude_date";
export const API_delete_forecast_exclude_date =
  BACKEND + "/api/store_info/delete_forecast_exclude_date?store_id=";

export const API_get_batch_guidance =
  BACKEND + "/api/get_batch_guidance?store_id=";
export const API_get_intraday_metrics =
  BACKEND + "/api/get_intraday_metrics?store_id=";
export const API_get_actual_intraday_metrics =
  BACKEND + "/api/get_actual_intraday_metrics?store_id=";
export const API_get_local_events = BACKEND + "/api/get_local_events?store_id=";

export const API_get_role_types = BACKEND + "/api/get_role_types?store_id=";
export const API_get_role_delete_impact = BACKEND + "/api/get_role_delete_impact";
export const API_get_role_type_delete_impact =
  BACKEND + "/api/get_role_type_delete_impact";
export const API_put_default_operating_hour =
  BACKEND + "/api/edit_default_operating_hour?store_id=";

export const API_put_role_type = BACKEND + "/api/edit_role_type?store_id=";
export const API_put_role = BACKEND + "/api/edit_role?store_id=";
export const API_put_station = BACKEND + "/api/edit_station?store_id=";
export const API_get_grade_weights =
  BACKEND + "/api/get_grade_weights?store_id=";
export const API_get_schedule_evaluation =
  BACKEND + "/api/store_info/schedule_evaluation";
export const API_get_labor_recap_report =
  BACKEND + "/api/store_info/labor_recap_report";
export const API_get_report_csv =
  BACKEND + "/api/store_info/report_csv";
export const API_get_weekly_labor_summary_report =
  BACKEND + "/api/store_info/weekly_labor_summary_report";
export const API_autoschedule_eval_runs =
  BACKEND + "/api/store_info/autoschedule_eval_runs";
export const API_get_autoschedule_role_profile =
  BACKEND + "/api/store_info/autoschedule_role_profile";
export const API_update_company_pipeline =
  BACKEND + "/api/company_info/update_company_pipeline";

// Contests
export const API_get_available_metrics =
  BACKEND + "/api/contest_info/get_available_metrics";
export const API_get_eligible_stores =
  BACKEND + "/api/contest_info/get_eligible_stores";
export const API_get_contests = BACKEND + "/api/contest_info/get_contests";
export const API_get_contest_leaderboard =
  BACKEND + "/api/contest_info/get_contest_leaderboard";
export const API_get_contest_timeline =
  BACKEND + "/api/contest_info/get_contest_timeline";
export const API_create_contest = BACKEND + "/api/contest_info/create_contest";
export const API_update_contest = BACKEND + "/api/contest_info/update_contest";
export const API_duplicate_contest =
  BACKEND + "/api/contest_info/duplicate_contest";
export const API_delete_contest = BACKEND + "/api/contest_info/delete_contest";

export const API_no_shows = BACKEND + "/api/no-shows?";
export const API_dayparts = BACKEND + "/api/dayparts?";
export const API_role_assignments = BACKEND + "/api/role-assignments?";
export const API_save_no_show = BACKEND + "/api/save_no_show";
export const API_update_role_assignment =
  BACKEND + "/api/update_role_assignment";
export const API_delete_role_assignment =
  BACKEND + "/api/delete_role_assignment";
export const API_save_dayparts = BACKEND + "/api/save_dayparts";
export const API_delete_daypart = BACKEND + "/api/delete_daypart";
export const API_auto_assign_roles = BACKEND + "/api/auto_assign_roles";
export const API_get_spent_labor_daily_summaries =
  BACKEND + "/api/store_info/get_spent_labor_daily_summaries?store_id=";
export const API_get_recent_avg_wages =
  BACKEND + "/api/store_info/get_recent_avg_wages?store_id=";

/// LOGIN APIs
export const API_REGISTRATION = "none";
export const API_LOGIN = BACKEND + "/api/dj-rest-auth/login/";
export const API_PWD_RESET = BACKEND + "/api/dj-rest-auth/password/reset/";
export const API_PWD_RESET_CONFIRM =
  BACKEND + "/api/dj-rest-auth/password/reset/confirm/";
export const API_PWD_CHANGE = BACKEND + "/api/dj-rest-auth/password/change/";

export const AMP_KEY = process.env.REACT_APP_AMP_KEY;

/// Mobile App Action APIs
export const API_list_availability_for_employee =
  BACKEND + "/api/schedule_info/list_availability_for_employee";

export const API_list_availability_requests_for_manager =
  BACKEND + "/api/schedule_info/list_availability_requests_for_manager";

export const API_list_availability_request_responses_for_manager =
  BACKEND +
  "/api/schedule_info/list_availability_request_responses_for_manager";

export const API_list_preferred_availability_for_employee =
  BACKEND + "/api/schedule_info/list_preferred_availability_for_employee";

export const API_list_preferred_availability_requests_for_manager =
  BACKEND +
  "/api/schedule_info/list_preferred_availability_requests_for_manager";

export const API_list_preferred_availability_request_responses_for_manager =
  BACKEND +
  "/api/schedule_info/list_preferred_availability_request_responses_for_manager";

export const API_get_schedule = BACKEND + "/api/store_info/get_schedule";
export const API_get_actual_used_schedule =
  BACKEND + "/api/store_info/get_actual_used_schedule?store_id=";

export const API_get_live_labor_violations =
  BACKEND + "/api/store_info/get_live_labor_violations?store_id=";

export const API_get_surveys_for_date_range =
  BACKEND + "/api/ovation_info/get_surveys_for_date_range?store_id=";

export const API_get_stats = BACKEND + "/api/store_info/get_daily_stats";

export const API_get_list_time_off_requests_for_manager =
  BACKEND + "/api/user_info/list_time_off_requests_for_manager";

export const API_get_list_time_off_requests_for_employee =
  BACKEND + "/api/user_info/list_time_off_requests_for_employee";

export const API_get_list_time_off_requests_for_stm =
  BACKEND + "/api/user_info/list_time_off_requests_for_stm";

export const API_get_shift_pool_for_employee =
  BACKEND + "/api/store_info/shift_pool_for_employee";

export const API_get_shift_pool_for_manager =
  BACKEND + "/api/store_info/shift_pool_for_manager";

export const API_get_manager_shift_pickup_request_responses =
  BACKEND + "/api/store_info/manager_shift_pickup_request_responses";

export const API_get_manager_shift_change_request_responses =
  BACKEND + "/api/store_info/manager_shift_change_request_responses";

export const API_get_employee_shift_pickup_request_responses =
  BACKEND + "/api/store_info/employee_shift_pickup_request_responses";

export const API_post_missed_shift =
  BACKEND + "/api/store_info/post_missed_shift";

// Employees Information

export const API_get_list_users = BACKEND + "/api/user_info/list_users";

export const API_get_referral_program =
  BACKEND + "/api/user_info/get_referral_program";

export const API_list_pos_store_team_members = BACKEND + "/api/pos_info/list_pos_store_team_members";

export const API_create_store_team_member_from_pos_store_team_member = BACKEND + "/api/pos_info/create_store_team_member_from_pos_store_team_member"
export const API_link_pos_store_team_member = BACKEND + "/api/pos_info/link_pos_store_team_member"
export const API_archive_pos_store_team_member = BACKEND + "/api/pos_info/archive_pos_store_team_member"

export const API_get_store_team_member =
  BACKEND + "/api/user_info/get_store_team_member";

export const API_archive_store_team_member =
  BACKEND + "/api/user_info/archive_store_team_member";

export const API_get_archived_store_team_members =
  BACKEND + "/api/user_info/get_archived_store_team_members";

export const API_get_stores_company_manager =
  BACKEND + "/api/store_info/get_stores_company_manager";

export const API_clone_or_reactivate_store_team_member =
  BACKEND + "/api/user_info/clone_or_reactivate_store_team_member";

export const API_post_store_team_member_only_permission_type_and_store_id =
  BACKEND +
  "/api/user_info/post_store_team_member_only_permission_type_and_store_id";

// LMS APIs

export const API_get_learning_tracks =
  BACKEND + "/api/lms_info/get_learning_tracks";

export const API_post_learning_track =
  BACKEND + "/api/lms_info/post_learning_track";

export const API_delete_learning_track =
  BACKEND + "/api/lms_info/delete_learning_track";

export const API_get_role_auto_enroll_count =
  BACKEND + "/api/lms_info/get_role_auto_enroll_count";

export const API_post_set_direct_assignability =
  BACKEND + "/api/lms_info/post_set_direct_assignability";
export const API_post_set_learning_asset_purpose =
  BACKEND + "/api/lms_info/post_set_learning_asset_purpose";

export const API_get_learning_modules =
  BACKEND + "/api/lms_info/get_learning_modules";

export const API_delete_learning_module =
  BACKEND + "/api/lms_info/delete_learning_module";

export const API_post_learning_module =
  BACKEND + "/api/lms_info/post_learning_module";

export const API_get_learning_section_summaries =
  BACKEND + "/api/lms_info/get_learning_section_summaries";

export const API_get_learning_section_detail =
  BACKEND + "/api/lms_info/get_learning_section_detail";

export const API_post_learning_section =
  BACKEND + "/api/lms_info/post_learning_section";

export const API_delete_learning_section =
  BACKEND + "/api/lms_info/delete_learning_section";

export const API_get_learning_quiz_summaries =
  BACKEND + "/api/lms_info/get_learning_quiz_summaries";

export const API_get_learning_quiz_detail =
  BACKEND + "/api/lms_info/get_learning_quiz_detail";

export const API_post_learning_quiz =
  BACKEND + "/api/lms_info/post_learning_quiz";

export const API_delete_learning_quiz =
  BACKEND + "/api/lms_info/delete_learning_quiz";

export const API_generate_quiz_questions_with_ai =
  BACKEND + "/api/lms_info/generate_quiz_questions_with_ai";

export const API_generate_content_with_ai =
  BACKEND + "/api/lms_info/generate_content_with_ai";

export const API_post_learning_generation_job_stream =
  BACKEND + "/api/lms_info/post_learning_generation_job_stream";

export const API_get_learning_generation_job =
  BACKEND + "/api/lms_info/get_learning_generation_job";

export const API_post_learning_generation_outline_approval =
  BACKEND + "/api/lms_info/post_learning_generation_outline_approval";

export const API_post_learning_generation_outline_edit_stream =
  BACKEND + "/api/lms_info/post_learning_generation_outline_edit_stream";

export const API_post_learning_generation_outline_revert =
  BACKEND + "/api/lms_info/post_learning_generation_outline_revert";

export const API_post_learning_generation_commit =
  BACKEND + "/api/lms_info/post_learning_generation_commit";

export const API_post_learning_generation_section_regenerate =
  BACKEND + "/api/lms_info/post_learning_generation_section_regenerate";

export const API_post_learning_generation_section_refine =
  BACKEND + "/api/lms_info/post_learning_generation_section_refine";

export const API_post_learning_generation_swipe_deck_refine =
  BACKEND + "/api/lms_info/post_learning_generation_swipe_deck_refine";

export const API_post_learning_generation_section_revert_asset =
  BACKEND + "/api/lms_info/post_learning_generation_section_revert_asset";

export const API_post_learning_generation_quiz_refine =
  BACKEND + "/api/lms_info/post_learning_generation_quiz_refine";

export const API_post_learning_generation_section_remove_asset =
  BACKEND + "/api/lms_info/post_learning_generation_section_remove_asset";

export const API_post_learning_generation_section_payload_update =
  BACKEND + "/api/lms_info/post_learning_generation_section_payload_update";

export const API_get_assistant_searchable_files =
  BACKEND + "/api/file_upload_info/get_assistant_searchable_files";

export const API_get_quiz_attempt_detail =
  BACKEND + "/api/lms_info/get_quiz_attempt_detail";

export const API_post_learning_file =
  BACKEND + "/api/lms_info/post_learning_file";

export const API_post_learning_file_with_eagerly_generated_presigned_url =
  BACKEND +
  "/api/lms_info/post_learning_file_with_eagerly_generated_presigned_url";

export const API_notify_learning_file_upload_complete =
  BACKEND + "/api/lms_info/notify_learning_file_upload_complete";

export const API_get_learning_media_library =
  BACKEND + "/api/lms_info/get_learning_media_library";

export const API_post_learning_file_from_document_image =
  BACKEND + "/api/lms_info/post_learning_file_from_document_image";

export const API_get_learning_file =
  BACKEND + "/api/lms_info/get_learning_file";

export const API_get_stores_with_learning_track_enrollment =
  BACKEND + "/api/lms_info/get_stores_with_learning_track_enrollment";

export const API_get_learning_track_enrollments_by_employee_for_store =
  BACKEND +
  "/api/lms_info/get_learning_track_enrollments_by_employee_for_store";

export const API_post_learning_track_enrollment =
  BACKEND + "/api/lms_info/post_learning_track_enrollment";

export const API_post_bulk_learning_track_enrollment =
  BACKEND + "/api/lms_info/post_bulk_learning_track_enrollment";

export const API_post_learning_track_unenrollment =
  BACKEND + "/api/lms_info/post_learning_track_unenrollment";

export const API_post_learning_track_enrollment_by_roles =
  BACKEND + "/api/lms_info/post_learning_track_enrollment_by_roles";

export const API_get_learning_modules_by_role =
  BACKEND + "/api/lms_info/get_learning_modules_by_role";

export const API_post_learning_module_star_threshold =
  BACKEND + "/api/lms_info/post_learning_module_star_threshold";

export const API_delete_learning_module_star_threshold =
  BACKEND + "/api/lms_info/delete_learning_module_star_threshold";

// Learning Forms (reusable form asset)
export const API_get_learning_form_summaries =
  BACKEND + "/api/lms_info/get_learning_form_summaries";

export const API_get_learning_form_detail =
  BACKEND + "/api/lms_info/get_learning_form_detail";

export const API_post_learning_form =
  BACKEND + "/api/lms_info/post_learning_form";

export const API_post_set_form_public_share =
  BACKEND + "/api/lms_info/post_set_form_public_share";
export const API_get_form_public_submissions =
  BACKEND + "/api/lms_info/get_form_public_submissions";
export const API_get_form_public_report =
  BACKEND + "/api/lms_info/get_form_public_report";
export const API_form_survey_chat_stream =
  BACKEND + "/api/lms_info/form_survey_chat_stream";

// Public (unauthenticated) form share endpoints. Call with bare axios, NOT
// getRightworkAPI (which forces an auth token).
export const API_get_public_form =
  BACKEND + "/api/lms_info/get_public_form/"; // + share_token
export const API_post_public_form_submit =
  BACKEND + "/api/lms_info/post_public_form_submit";
export const API_post_public_form_opened =
  BACKEND + "/api/lms_info/post_public_form_opened";

export const API_delete_learning_form =
  BACKEND + "/api/lms_info/delete_learning_form";

export const API_post_learning_form_completion =
  BACKEND + "/api/lms_info/post_learning_form_completion";

export const API_get_learning_form_completion =
  BACKEND + "/api/lms_info/get_learning_form_completion";

export const API_post_learning_form_grade =
  BACKEND + "/api/lms_info/post_learning_form_grade";

export const API_post_learning_form_ai_grade_suggestion =
  BACKEND + "/api/lms_info/post_learning_form_ai_grade_suggestion";

export const API_get_learning_form_submission_for_grading =
  BACKEND + "/api/lms_info/get_learning_form_submission_for_grading";

// Training Badges (earned-by-training credentials)
export const API_get_training_badges =
  BACKEND + "/api/lms_info/get_training_badges";

export const API_post_training_badge =
  BACKEND + "/api/lms_info/post_training_badge";

export const API_archive_training_badge =
  BACKEND + "/api/lms_info/archive_training_badge";

export const API_get_earned_badges =
  BACKEND + "/api/lms_info/get_earned_badges";

export const API_revoke_earned_badge =
  BACKEND + "/api/lms_info/revoke_earned_badge";

// Learning Roleplays (AI conversation practice asset)
export const API_get_learning_roleplay_summaries =
  BACKEND + "/api/lms_info/get_learning_roleplay_summaries";

export const API_get_learning_roleplay_detail =
  BACKEND + "/api/lms_info/get_learning_roleplay_detail";

export const API_post_learning_roleplay =
  BACKEND + "/api/lms_info/post_learning_roleplay";

export const API_delete_learning_roleplay =
  BACKEND + "/api/lms_info/delete_learning_roleplay";

export const API_post_learning_roleplay_attempt_start =
  BACKEND + "/api/lms_info/post_learning_roleplay_attempt_start";

// SSE — consume with streamRightworkAPI, not axios.
export const API_post_learning_roleplay_turn_stream =
  BACKEND + "/api/lms_info/post_learning_roleplay_turn_stream";

export const API_post_learning_roleplay_attempt_complete =
  BACKEND + "/api/lms_info/post_learning_roleplay_attempt_complete";

export const API_get_learning_roleplay_attempt =
  BACKEND + "/api/lms_info/get_learning_roleplay_attempt";

export const API_get_learning_roleplay_attempts =
  BACKEND + "/api/lms_info/get_learning_roleplay_attempts";

export const API_generate_roleplay_with_ai =
  BACKEND + "/api/lms_info/generate_roleplay_with_ai";

// Generate or AI-edit a form draft (pass current_form for edit mode).
export const API_generate_form_with_ai =
  BACKEND + "/api/lms_info/generate_form_with_ai";

export const API_generate_contest_with_ai =
  BACKEND + "/api/contest_info/generate_contest_with_ai";

export const API_generate_plan_task_with_ai =
  BACKEND + "/api/plan_info/generate_plan_task_with_ai";

// Generate a cover image from the (unsaved) persona + situation; returns a
// LearningFile bound to the scenario on the next save via cover_file_uuid.
export const API_generate_roleplay_cover_with_ai =
  BACKEND + "/api/lms_info/generate_roleplay_cover_with_ai";

// Stateless editor preview (SSE turn stream + grade) — nothing is recorded.
export const API_post_learning_roleplay_preview_turn_stream =
  BACKEND + "/api/lms_info/post_learning_roleplay_preview_turn_stream";

export const API_post_learning_roleplay_preview_grade =
  BACKEND + "/api/lms_info/post_learning_roleplay_preview_grade";

// Resolves unsaved editor knowledge sources into the grounding digest once
// per preview session; the editor holds the string client-side.
export const API_post_learning_roleplay_preview_knowledge =
  BACKEND + "/api/lms_info/post_learning_roleplay_preview_knowledge";

// Voice mode (OpenAI Realtime): session mints + client-reported turn sync.
export const API_post_learning_roleplay_voice_session =
  BACKEND + "/api/lms_info/post_learning_roleplay_voice_session";

export const API_post_learning_roleplay_voice_preview_session =
  BACKEND + "/api/lms_info/post_learning_roleplay_voice_preview_session";

export const API_post_learning_roleplay_voice_turns =
  BACKEND + "/api/lms_info/post_learning_roleplay_voice_turns";

// File upload

export const API_post_file_upload_with_eagerly_generated_presigned_url =
  BACKEND +
  "/api/file_upload_info/post_file_upload_with_eagerly_generated_presigned_url";

export const API_post_bulk_file_upload_with_eagerly_generated_presigned_urls =
  BACKEND +
  "/api/file_upload_info/post_bulk_file_upload_with_eagerly_generated_presigned_urls";

export const API_get_file_upload =
  BACKEND + "/api/file_upload_info/get_file_upload";

export const API_notify_file_upload_complete =
  BACKEND + "/api/file_upload_info/notify_file_upload_complete";

export const API_post_resolve_ai_sources_folder =
  BACKEND + "/api/file_upload_info/post_resolve_ai_sources_folder";
export const API_get_file_upload_indexing_status =
  BACKEND + "/api/file_upload_info/get_file_upload_indexing_status";
export const API_get_file_upload_text =
  BACKEND + "/api/file_upload_info/get_file_upload_text";
export const API_get_file_upload_document_images =
  BACKEND + "/api/file_upload_info/get_file_upload_document_images";
export const API_post_discover_site_pages =
  BACKEND + "/api/file_upload_info/post_discover_site_pages";
export const API_post_file_upload_from_url =
  BACKEND + "/api/file_upload_info/post_file_upload_from_url";

export const API_post_file_upload_from_learning_file =
  BACKEND + "/api/file_upload_info/post_file_upload_from_learning_file";

export const API_delete_file_upload =
  BACKEND + "/api/file_upload_info/delete_file_upload/";

export const API_get_trash =
  BACKEND + "/api/file_upload_info/get_trash";

export const API_restore_item =
  BACKEND + "/api/file_upload_info/restore_item";

export const API_permanent_delete_item =
  BACKEND + "/api/file_upload_info/permanent_delete_item";

// LMS APIs employee side

export const API_get_learning_track_enrollment_summaries_for_employee =
  BACKEND +
  "/api/lms_info/get_learning_track_enrollment_summaries_for_employee";

export const API_get_learning_track_enrollment_detail_for_employee =
  BACKEND + "/api/lms_info/get_learning_track_enrollment_detail_for_employee";

export const API_post_learning_section_completed =
  BACKEND + "/api/lms_info/post_learning_section_completed";

export const API_post_learning_block_user_passed =
  BACKEND + "/api/lms_info/post_learning_block_user_passed";

export const API_get_learning_swipe_deck_for_employee =
  BACKEND + "/api/lms_info/get_learning_swipe_deck_for_employee";

export const API_post_learning_swipe_card_response =
  BACKEND + "/api/lms_info/post_learning_swipe_card_response";

export const API_post_learning_swipe_deck_completion =
  BACKEND + "/api/lms_info/post_learning_swipe_deck_completion";

export const API_get_learning_swipe_deck_summaries =
  BACKEND + "/api/lms_info/get_learning_swipe_deck_summaries";

export const API_get_learning_swipe_deck_detail =
  BACKEND + "/api/lms_info/get_learning_swipe_deck_detail";

export const API_post_learning_swipe_deck =
  BACKEND + "/api/lms_info/post_learning_swipe_deck";

export const API_post_set_swipe_deck_public_share =
  BACKEND + "/api/lms_info/post_set_swipe_deck_public_share";

// Public (unauthenticated) swipe deck share endpoints. Call with bare axios,
// NOT getRightworkAPI (which forces an auth token).
export const API_get_public_swipe_deck =
  BACKEND + "/api/lms_info/get_public_swipe_deck/"; // + share_token
export const API_post_public_swipe_card_submit =
  BACKEND + "/api/lms_info/post_public_swipe_card_submit";
export const API_post_public_swipe_deck_opened =
  BACKEND + "/api/lms_info/post_public_swipe_deck_opened";

export const API_delete_learning_swipe_deck =
  BACKEND + "/api/lms_info/delete_learning_swipe_deck";

export const API_generate_swipe_deck_with_ai =
  BACKEND + "/api/lms_info/generate_swipe_deck_with_ai";

export const API_generate_swipe_card_image_with_ai =
  BACKEND + "/api/lms_info/generate_swipe_card_image_with_ai";

export const API_split_learning_video =
  BACKEND + "/api/lms_info/post_split_learning_video";

export const API_suggest_video_chapters =
  BACKEND + "/api/lms_info/post_suggest_video_chapters";

export const API_post_learning_signature_completion =
  BACKEND + "/api/lms_info/post_learning_signature_completion";

export const API_get_learning_signature_completion =
  BACKEND + "/api/lms_info/get_learning_signature_completion";

export const API_delete_signature_document =
  BACKEND + "/api/lms_info/delete_signature_document";

export const API_post_user_signature =
  BACKEND + "/api/lms_info/post_user_signature";

export const API_get_user_signature =
  BACKEND + "/api/lms_info/get_user_signature";

export const API_post_learning_document_upload_completion =
  BACKEND + "/api/lms_info/post_learning_document_upload_completion";

export const API_get_learning_document_upload_completion =
  BACKEND + "/api/lms_info/get_learning_document_upload_completion";

export const API_delete_document_upload =
  BACKEND + "/api/lms_info/delete_document_upload";

export const API_remove_record_from_profile =
  BACKEND + "/api/lms_info/remove_record_from_profile";

export const API_post_learning_manager_input_completion =
  BACKEND + "/api/lms_info/post_learning_manager_input_completion";

export const API_get_learning_manager_input_completion =
  BACKEND + "/api/lms_info/get_learning_manager_input_completion";

export const API_get_learning_records_for_store =
  BACKEND + "/api/lms_info/get_learning_records_for_store";

export const API_get_learning_record_detail_for_store =
  BACKEND + "/api/lms_info/get_learning_record_detail_for_store";

export const API_get_pending_form_grades_for_store =
  BACKEND + "/api/lms_info/get_pending_form_grades_for_store";

// Chat APIs

export const API_get_stream_user_token =
  BACKEND + "/api/chat_info/get_stream_user_token";

export const API_get_chat_users = BACKEND + "/api/chat_info/get_chat_users";

export const API_create_chat_channel =
  BACKEND + "/api/chat_info/create_chat_channel";

export const API_promote_channel_moderator =
  BACKEND + "/api/chat_info/promote_channel_moderator";

export const API_demote_channel_moderator =
  BACKEND + "/api/chat_info/demote_channel_moderator";

export const API_delete_channel_message =
  BACKEND + "/api/chat_info/delete_channel_message";

export const API_add_direct_message_members =
  BACKEND + "/api/chat_info/add_direct_message_members";

export const API_leave_chat_channel =
  BACKEND + "/api/chat_info/leave_chat_channel";

export const API_delete_chat_channel =
  BACKEND + "/api/chat_info/delete_chat_channel";

export const API_remove_chat_channel_member =
  BACKEND + "/api/chat_info/remove_chat_channel_member";
export const API_schedule_chat_message =
  BACKEND + "/api/chat_info/schedule_chat_message";
export const API_list_scheduled_chat_messages =
  BACKEND + "/api/chat_info/list_scheduled_chat_messages";
export const API_update_scheduled_chat_message =
  BACKEND + "/api/chat_info/update_scheduled_chat_message";
export const API_cancel_scheduled_chat_message =
  BACKEND + "/api/chat_info/cancel_scheduled_chat_message";
export const API_send_scheduled_chat_message_now =
  BACKEND + "/api/chat_info/send_scheduled_chat_message_now";

// Resend Welcome Email

export const API_resend_welcome_email =
  BACKEND + "/api/user_info/resend_welcome_email";
export const API_send_welcome_message =
  BACKEND + "/api/user_info/send_welcome_message";
export const API_get_welcome_message_status =
  BACKEND + "/api/user_info/get_welcome_message_status";
export const API_get_invite =
  BACKEND + "/api/user_info/get_invite/";
export const API_accept_invite =
  BACKEND + "/api/user_info/accept_invite";
export const API_get_toast_credential_link =
  BACKEND + "/api/pos_info/toast_credential_link/";
export const API_submit_toast_credential_link =
  BACKEND + "/api/pos_info/submit_toast_credential_link";
export const API_create_toast_credential_link =
  BACKEND + "/api/pos_info/create_toast_credential_link";

export const API_drawer_notifications =
  BACKEND + "/api/notification_info/drawer_notifications";

export const API_get_notification_settings =
  BACKEND + "/api/notification_info/get_settings";
export const API_report_email_subscription =
  BACKEND + "/api/notification_info/report_email_subscription";
export const API_report_email_subscription_stores =
  BACKEND + "/api/notification_info/report_email_subscription_stores";
export const API_resubscribe_email =
  BACKEND + "/api/notification_info/resubscribe";
export const API_unsubscribe_all_email =
  BACKEND + "/api/notification_info/unsubscribe_all_email";

export const API_send_support_feedback =
  BACKEND + "/api/notification_info/send_support_feedback";

export const API_get_all_time_off_requests =
  BACKEND + "/api/user_info/get_all_time_off_requests?store_id=";

export const API_get_blackout_dates =
  BACKEND + "/api/user_info/get_blackout_dates";

export const API_create_blackout_date =
  BACKEND + "/api/user_info/create_blackout_date";

export const API_delete_blackout_date =
  BACKEND + "/api/user_info/delete_blackout_date";

export const API_list_frequent_schedules =
  BACKEND + "/api/user_info/list_frequent_schedules?store_id=";

export const API_get_manager_stores_rightwork_data =
  BACKEND + "/api/store_info/get_manager_stores_rightwork_data";

export const API_update_manager_store_rightwork_data =
  BACKEND + "/api/store_info/update_manager_store_rightwork_data";

export const API_get_manager_stores_integration_data =
  BACKEND + "/api/store_info/get_manager_stores_integration_data";

export const API_post_manager_store_integration_data =
  BACKEND + "/api/store_info/post_manager_store_integration_data";

export const API_get_store_pos_integration_summary =
  BACKEND + "/api/store_info/get_store_pos_integration_summary";

export const API_start_store_pos_integration_backfill =
  BACKEND + "/api/store_info/start_store_pos_integration_backfill";

export const API_start_store_actuals_backfill =
  BACKEND + "/api/store_info/start_store_actuals_backfill";

export const API_refresh_live_day_pos_data =
  BACKEND + "/api/store_info/refresh_live_day_pos_data";

export const API_get_company_feature_settings =
  BACKEND + "/api/store_info/get_company_feature_settings";

export const API_bulk_update_feature_settings =
  BACKEND + "/api/store_info/bulk_update_feature_settings";

export const API_get_store_groups = BACKEND + "/api/store_info/get_store_groups";
export const API_save_store_group = BACKEND + "/api/store_info/save_store_group";
export const API_delete_store_group = BACKEND + "/api/store_info/delete_store_group";
export const API_assign_store_to_group = BACKEND + "/api/store_info/assign_store_to_group";

export const API_get_tip_policies = BACKEND + "/api/tip_info/get_tip_policies";
export const API_save_tip_policy = BACKEND + "/api/tip_info/save_tip_policy";
export const API_archive_tip_policy = BACKEND + "/api/tip_info/archive_tip_policy";
export const API_assign_tip_policy_stores = BACKEND + "/api/tip_info/assign_tip_policy_stores";
export const API_unassign_tip_policy_store = BACKEND + "/api/tip_info/unassign_tip_policy_store";
export const API_save_tip_settings = BACKEND + "/api/tip_info/save_tip_settings";
export const API_recompute_tips = BACKEND + "/api/tip_info/recompute_tips";
export const API_get_tip_close_summary = BACKEND + "/api/tip_info/get_tip_close_summary";
export const API_get_tip_store_breakdown = BACKEND + "/api/tip_info/get_tip_store_breakdown";
export const API_get_tip_employee_detail = BACKEND + "/api/tip_info/get_tip_employee_detail";
export const API_save_tip_adjustment = BACKEND + "/api/tip_info/save_tip_adjustment";
export const API_delete_tip_adjustment = BACKEND + "/api/tip_info/delete_tip_adjustment";
export const API_confirm_tip_closeout = BACKEND + "/api/tip_info/confirm_tip_closeout";
export const API_reopen_tip_closeout = BACKEND + "/api/tip_info/reopen_tip_closeout";
export const API_preview_tip_export = BACKEND + "/api/tip_info/preview_tip_export";
export const API_download_tip_export = BACKEND + "/api/tip_info/download_tip_export";
export const API_get_tip_exports = BACKEND + "/api/tip_info/get_tip_exports";
export const API_get_my_tips = BACKEND + "/api/tip_info/get_my_tips";

export const API_toast_inventory = BACKEND + "/api/pos_info/toast_inventory";
export const API_get_prep_plan = BACKEND + "/api/inventory_info/get_prep_plan";
export const API_get_prep_history = BACKEND + "/api/inventory_info/get_prep_history";
export const API_post_prep_count = BACKEND + "/api/inventory_info/post_prep_count";
export const API_post_prep_results = BACKEND + "/api/inventory_info/post_prep_results";
export const API_list_pos_stores = BACKEND + "/api/pos_info/list_pos_stores"

export const API_refresh_pos_locations =
  BACKEND + "/api/pos_info/refresh_pos_locations";

export const API_create_store_from_pos_store =  BACKEND + "/api/pos_info/create_store_from_pos_store"

export const API_archive_pos_store = BACKEND + "/api/pos_info/archive_pos_store"


// Labor model

export const API_get_labor_model_scenarios =
  BACKEND + "/api/labor_model_info/get_labor_model_scenarios";
export const API_get_labor_model_scenario =
  BACKEND + "/api/labor_model_info/get_labor_model_scenario";
export const API_get_labor_model_publication =
  BACKEND + "/api/labor_model_info/get_labor_model_publication";
export const API_create_labor_model_scenario =
  BACKEND + "/api/labor_model_info/create_labor_model_scenario";
export const API_update_labor_model_scenario =
  BACKEND + "/api/labor_model_info/update_labor_model_scenario";
export const API_replace_labor_model_scenario_snapshot =
  BACKEND + "/api/labor_model_info/replace_labor_model_scenario_snapshot";
export const API_archive_labor_model_scenario =
  BACKEND + "/api/labor_model_info/archive_labor_model_scenario";
export const API_compare_labor_model_scenario =
  BACKEND + "/api/labor_model_info/compare_labor_model_scenario";
export const API_evaluate_labor_model_scenario =
  BACKEND + "/api/labor_model_info/evaluate_labor_model_scenario";
export const API_get_labor_model_assistant_session =
  BACKEND + "/api/labor_model_info/get_labor_model_assistant_session";
export const API_labor_model_assistant_chat =
  BACKEND + "/api/labor_model_info/labor_model_assistant_chat";
export const API_reset_labor_model_assistant_session =
  BACKEND + "/api/labor_model_info/reset_labor_model_assistant_session";
export const API_resolve_labor_model_assistant_proposal =
  BACKEND + "/api/labor_model_info/resolve_labor_model_assistant_proposal";

export const API_get_labor_drivers =
  BACKEND + "/api/labor_model_info/get_labor_drivers";

export const API_post_labor_driver_company_attribute =
  BACKEND + "/api/labor_model_info/post_labor_driver_company_attribute";

export const API_post_labor_driver_sales =
  BACKEND + "/api/labor_model_info/post_labor_driver_sales";
export const API_post_labor_driver_routed_sales =
  BACKEND + "/api/labor_model_info/post_labor_driver_routed_sales";
export const API_get_labor_driver_sales_metadata =
  BACKEND + "/api/labor_model_info/get_labor_driver_sales_metadata";
export const API_get_labor_driver_sales_filter_values =
  BACKEND + "/api/labor_model_info/get_labor_driver_sales_filter_values";
export const API_preview_labor_driver_sales =
  BACKEND + "/api/labor_model_info/preview_labor_driver_sales";

export const API_post_backfill_labor_driver_sales =
  BACKEND + "/api/labor_model_info/backfill_labor_driver_sales";
export const API_post_backfill_labor_driver_routed_sales =
  BACKEND + "/api/labor_model_info/backfill_labor_driver_routed_sales";
export const API_get_onboarding_summary =
  BACKEND + "/api/company_info/get_onboarding_summary";
export const API_update_onboarding_preferences =
  BACKEND + "/api/company_info/update_onboarding_preferences";
export const API_advance_onboarding_step =
  BACKEND + "/api/company_info/advance_onboarding_step";
export const API_run_onboarding_automation =
  BACKEND + "/api/company_info/run_onboarding_automation";
export const API_get_onboarding_job_status =
  BACKEND + "/api/company_info/get_onboarding_job_status";
export const API_start_onboarding_setup =
  BACKEND + "/api/company_info/start_onboarding_setup";
export const API_get_onboarding_setup_run =
  BACKEND + "/api/company_info/get_onboarding_setup_run";
export const API_confirm_onboarding_setup_locations =
  BACKEND + "/api/company_info/confirm_onboarding_setup_locations";
export const API_retry_onboarding_setup =
  BACKEND + "/api/company_info/retry_onboarding_setup";
export const API_recommend_labor_model_concepts =
  BACKEND + "/api/labor_model_info/recommend_labor_model_concepts";
export const API_run_labor_standard_optimization =
  BACKEND + "/api/labor_model_info/run_labor_standard_optimization";
export const API_get_labor_standard_optimization_runs =
  BACKEND + "/api/labor_model_info/get_labor_standard_optimization_runs";
export const API_apply_labor_standard_optimization =
  BACKEND + "/api/labor_model_info/apply_labor_standard_optimization";
export const API_get_billing_settings =
  BACKEND + "/api/billing_info/get_billing_settings";
export const API_update_billing_settings =
  BACKEND + "/api/billing_info/update_billing_settings";
export const API_create_stripe_customer =
  BACKEND + "/api/billing_info/create_stripe_customer";
export const API_create_billing_portal_session =
  BACKEND + "/api/billing_info/create_billing_portal_session";
export const API_get_billed_locations =
  BACKEND + "/api/billing_info/get_billed_locations";
export const API_request_location_change =
  BACKEND + "/api/billing_info/request_location_change";
export const API_get_internal_billing_overview =
  BACKEND + "/api/billing_info/get_internal_billing_overview";
export const API_update_internal_billing_rates =
  BACKEND + "/api/billing_info/update_internal_billing_rates";
export const API_update_internal_store_status =
  BACKEND + "/api/billing_info/update_internal_store_status";
export const API_complete_internal_billing_request =
  BACKEND + "/api/billing_info/complete_internal_billing_request";
export const API_create_internal_stripe_customer =
  BACKEND + "/api/billing_info/create_internal_stripe_customer";

export const API_get_company_users =
  BACKEND + "/api/company_info/get_company_users";
export const API_bulk_grant_store_access =
  BACKEND + "/api/company_info/bulk_grant_store_access";
export const API_bulk_archive =
  BACKEND + "/api/company_info/bulk_archive";
export const API_bulk_change_permission =
  BACKEND + "/api/company_info/bulk_change_permission";
export const API_bulk_change_overrides =
  BACKEND + "/api/company_info/bulk_change_overrides";
export const API_update_company_user_profile =
  BACKEND + "/api/company_info/update_company_user_profile";
export const API_lookup_user_by_email =
  BACKEND + "/api/company_info/lookup_user_by_email";
export const API_add_user_to_company_team =
  BACKEND + "/api/company_info/add_user_to_company_team";
export const API_send_welcome_to_company_user =
  BACKEND + "/api/company_info/send_welcome_to_company_user";

export const API_delete_labor_driver =
  BACKEND + "/api/labor_model_info/delete_labor_driver";

export const API_get_labor_standards =
  BACKEND + "/api/labor_model_info/get_labor_standards";

export const API_post_labor_standard =
  BACKEND + "/api/labor_model_info/post_labor_standard";

export const API_delete_labor_standard =
  BACKEND + "/api/labor_model_info/delete_labor_standard";

export const API_get_company_time_windows =
  BACKEND + "/api/labor_model_info/get_company_time_windows";

export const API_edit_company_time_window =
  BACKEND + "/api/labor_model_info/edit_company_time_window";

export const API_delete_company_time_windows =
  BACKEND + "/api/labor_model_info/delete_company_time_windows";

export const API_get_labor_test_results =
  BACKEND + "/api/labor_model_info/get_test_results";

export const API_get_labor_program_flags =
  BACKEND + "/api/labor_model_info/get_labor_program_flags";

export const API_post_labor_program_flag_company =
  BACKEND + "/api/labor_model_info/post_labor_program_flag_company";

export const API_delete_labor_program_flag_company =
  BACKEND + "/api/labor_model_info/delete_labor_program_flag_company";

export const API_get_labor_program_flags_with_store_overrides =
  BACKEND +
  "/api/labor_model_info/get_labor_program_flags_with_store_overrides";

export const API_post_labor_program_flag_store =
  BACKEND + "/api/labor_model_info/post_labor_program_flag_store";

export const API_publish_labor_standard =
  BACKEND + "/api/labor_model_info/publish_labor_standard";

export const API_get_labor_model_publications =
  BACKEND + "/api/labor_model_info/get_labor_model_publications";

export const API_restore_labor_model_publication =
  BACKEND + "/api/labor_model_info/restore_labor_model_publication";

export const API_revert_labor_standard =
  BACKEND + "/api/labor_model_info/revert_labor_standard";

// Get store proficiencies
export const API_get_stores_company_admin =
  BACKEND + "/api/store_info/get_stores_company_admin";

export const API_post_store_proficiency =
  BACKEND + "/api/store_info/post_store_proficiency";

export const API_post_store_labor_budget_target =
  BACKEND + "/api/store_info/post_store_labor_budget_target";

export const API_post_store_labor_model_fit_factor =
  BACKEND + "/api/store_info/post_store_labor_model_fit_factor";

export const API_post_labor_plan_changes =
  BACKEND + "/api/store_info/post_labor_plan_changes";

export const API_get_labor_plan_summary =
  BACKEND + "/api/store_info/get_labor_plan_summary";

export const API_post_store_proficiency_bulk =
  BACKEND + "/api/store_info/post_store_proficiency_bulk";

export const API_test_store_proficiency_forecast =
  BACKEND + "/api/store_info/test_store_proficiency_forecast";

export const API_evaluate_store_adjustments =
  BACKEND + "/api/store_info/evaluate_store_adjustments";

export const API_recommend_store_adjustments =
  BACKEND + "/api/store_info/recommend_store_adjustments";

export const API_get_labor_driver_store_attributes =
  BACKEND + "/api/labor_model_info/get_labor_driver_store_attributes";

export const API_post_labor_driver_store_attribute =
  BACKEND + "/api/labor_model_info/post_labor_driver_store_attribute";

// Clock Info
export const API_get_employee_clock_data =
  BACKEND + "/api/clock_info/get_employee_clock_data";

export const API_post_timecard_clock_in =
  BACKEND + "/api/clock_info/timecard_clock_in";

export const API_post_timecard_clock_out =
  BACKEND + "/api/clock_info/timecard_clock_out";

export const API_post_timecard_paid_break_confirmation =
  BACKEND + "/api/clock_info/timecard_paid_break_confirmation";

export const API_post_timecard_break_clock_in =
  BACKEND + "/api/clock_info/timecard_break_clock_in";

export const API_post_timecard_break_clock_out =
  BACKEND + "/api/clock_info/timecard_break_clock_out";

export const API_get_timecards_for_store =
  BACKEND + "/api/clock_info/get_timecards_for_store";

export const API_get_timecards_for_employee =
  BACKEND + "/api/clock_info/get_timecards_for_employee";

export const API_post_timecard = BACKEND + "/api/clock_info/post_timecard";

export const API_get_pay_periods = BACKEND + "/api/clock_info/get_pay_periods";

export const API_get_pay_periods_by_company = BACKEND + "/api/clock_info/get_pay_periods_by_company";

export const API_get_timecards_for_company = BACKEND + "/api/clock_info/get_timecards_for_company";

export const API_export_timecards_gusto = BACKEND + "/api/clock_info/export_timecards_gusto";

export const API_export_timecards_paylocity = BACKEND + "/api/clock_info/export_timecards_paylocity";

export const API_export_tips_paylocity = BACKEND + "/api/clock_info/export_tips_paylocity";

export const API_get_pay_period_employees =
  BACKEND + "/api/clock_info/get_pay_period_employees";

export const API_delete_timecard = BACKEND + "/api/clock_info/delete_timecard";

export const API_get_timecard_hours_split =
  BACKEND + "/api/clock_info/get_timecard_hours_split";

export const API_post_timecards_status =
  BACKEND + "/api/clock_info/post_timecards_status";

export const API_get_timecard_config =
  BACKEND + "/api/clock_info/get_timecard_config";

export const API_post_timecard_config =
  BACKEND + "/api/clock_info/post_timecard_config";

export const API_get_live_alert_config =
  BACKEND + "/api/clock_info/get_live_alert_config";

export const API_post_live_alert_config =
  BACKEND + "/api/clock_info/post_live_alert_config";

export const API_get_company_timecard_config =
  BACKEND + "/api/clock_info/get_company_timecard_config";

export const API_post_company_timecard_config =
  BACKEND + "/api/clock_info/post_company_timecard_config";

export const API_get_company_live_alert_config =
  BACKEND + "/api/clock_info/get_company_live_alert_config";

export const API_post_company_live_alert_config =
  BACKEND + "/api/clock_info/post_company_live_alert_config";

export const API_bulk_apply_config_defaults =
  BACKEND + "/api/clock_info/bulk_apply_config_defaults";


export const API_post_pay_period_approval =
  BACKEND + "/api/clock_info/post_pay_period_approval";
export const API_post_timecard_change_request =
  BACKEND + "/api/clock_info/post_timecard_change_request";
export const API_manage_timecard_change_request =
  BACKEND + "/api/clock_info/manage_timecard_change_request";
export const API_review_timecard_change_request =
  BACKEND + "/api/clock_info/review_timecard_change_request";

export const API_post_pay_period =
  BACKEND + "/api/clock_info/post_pay_period";

export const API_post_pay_period_tip_amounts =
  BACKEND + "/api/clock_info/post_pay_period_tip_amounts";

// Certificates
export const API_get_certificates =
  BACKEND + "/api/certificate_info/get_certificates";

export const API_get_certificates_for_store =
  BACKEND + "/api/certificate_info/get_certificates_for_store";

export const API_post_certificate =
  BACKEND + "/api/certificate_info/post_certificate";

export const API_delete_certificate =
  BACKEND + "/api/certificate_info/delete_certificate";

export const API_get_certificate_types =
  BACKEND + "/api/certificate_info/get_certificate_types";

export const API_post_certificate_type =
  BACKEND + "/api/certificate_info/post_certificate_type";

export const API_archive_certificate_type =
  BACKEND + "/api/certificate_info/archive_certificate_type";

export const API_set_certificate_type_overview_visibility =
  BACKEND + "/api/certificate_info/set_certificate_type_overview_visibility";

export const API_set_certificate_type_role_requirements =
  BACKEND + "/api/certificate_info/set_certificate_type_role_requirements";

// Forecast historical context
export const API_get_historical_sales_context =
  BACKEND + "/api/store_info/get_historical_sales_context?store_id=";

// Employees
export const API_post_store_team_member =
  BACKEND + "/api/user_info/post_store_team_member";

export const API_update_emergency_contact =
  BACKEND + "/api/user_info/update_emergency_contact";

export const API_get_store_team_member_wages =
  BACKEND + "/api/user_info/get_store_team_member_wages";

export const API_post_store_team_member_wage =
  BACKEND + "/api/user_info/post_store_team_member_wage";

export const API_post_store_team_member_labor_exempt =
  BACKEND + "/api/user_info/post_store_team_member_labor_exempt";

export const API_post_store_team_member_clock_in_expectation =
  BACKEND + "/api/user_info/post_store_team_member_clock_in_expectation";

export const API_get_effective_wages =
  BACKEND + "/api/user_info/get_effective_wages";

export const API_post_payroll_external_id =
  BACKEND + "/api/user_info/post_payroll_external_id";

// Mobile App Post Requests
export const API_drop_shift = BACKEND + "/api/store_info/drop_shift";

export const API_rescind_drop_shift =
  BACKEND + "/api/store_info/rescind_drop_shift";

export const API_pickup_shift = BACKEND + "/api/store_info/pickup_shift";

export const API_rescind_pickup_shift =
  BACKEND + "/api/store_info/rescind_pickup_shift";

export const API_hide_shift_change_request =
  BACKEND + "/api/store_info/hide_shift_change_request";

export const API_manager_reject_shift_drop =
  BACKEND + "/api/store_info/manager_reject_shift_drop";

export const API_manager_accept_shift_drop =
  BACKEND + "/api/store_info/manager_accept_shift_drop";

export const API_manager_shift_pickup_request_response =
  BACKEND + "/api/store_info/manager_shift_pickup_request_response";

export const API_manager_approve_shift_pickup =
  BACKEND + "/api/store_info/manager_approve_shift_pickup";

export const API_manager_assign_open_shift =
  BACKEND + "/api/store_info/manager_assign_open_shift";

export const API_create_availability_request =
  BACKEND + "/api/schedule_info/create_availability_request";

export const API_rescind_availability_request =
  BACKEND + "/api/schedule_info/rescind_availability_request";

export const API_manager_rescind_availability_request =
  BACKEND + "/api/schedule_info/manager_rescind_availability_request";

export const API_delete_availability_request =
  BACKEND + "/api/schedule_info/delete_availability_request";

export const API_hide_availability_request =
  BACKEND + "/api/schedule_info/hide_availability_request";

export const API_create_preferred_availability_request =
  BACKEND + "/api/schedule_info/create_preferred_availability_request";

export const API_rescind_preferred_availability_request =
  BACKEND + "/api/schedule_info/rescind_preferred_availability_request";

export const API_delete_preferred_availability_request =
  BACKEND + "/api/schedule_info/delete_preferred_availability_request";

export const API_hide_preferred_availability_request =
  BACKEND + "/api/schedule_info/hide_preferred_availability_request";

export const API_request_time_off = BACKEND + "/api/user_info/request_time_off";

export const API_rescind_time_off_request =
  BACKEND + "/api/user_info/rescind_time_off_request";

export const API_delete_time_off_request =
  BACKEND + "/api/user_info/delete_time_off_request";

export const API_delete_temporary_availability =
  BACKEND + "/api/schedule_info/delete_temporary_availability";

export const API_hide_time_off_request =
  BACKEND + "/api/user_info/hide_time_off_request";

export const API_manager_respond_to_availability_request =
  BACKEND + "/api/schedule_info/manager_respond_to_availability_request";

export const API_manager_respond_to_preferred_availability_request =
  BACKEND +
  "/api/schedule_info/manager_respond_to_preferred_availability_request";

export const API_respond_to_time_off_request =
  BACKEND + "/api/user_info/respond_to_time_off_request";

export const API_push_notification_token =
  BACKEND + "/api/notification_info/register_expo_push_notification_token";

export const API_hide_drawer_notification =
  BACKEND + "/api/notification_info/hide_drawer_notification";

export const API_hide_all_drawer_notifications =
  BACKEND + "/api/notification_info/hide_all_drawer_notifications";
export const API_send_notification_to_employee =
  BACKEND + "/api/notification_info/send_notification_to_employee";
export const API_subscribe_live_labor_alerts =
  BACKEND + "/api/notification_info/subscribe_live_labor_alerts";
export const API_unsubscribe_live_labor_alerts =
  BACKEND + "/api/notification_info/unsubscribe_live_labor_alerts";
export const API_get_live_labor_subscriptions =
  BACKEND + "/api/notification_info/get_live_labor_subscriptions?store_id=";

export const API_calculate_metric =
  BACKEND + "/api/store_info/calculate_metric";
export const API_get_company_metrics =
  BACKEND + "/api/store_info/get_company_metrics";
export const API_get_event_metrics =
  BACKEND + "/api/analytics_info/get_event_metrics/";
export const API_save_report =
  BACKEND + "/api/store_info/save_report";
export const API_get_saved_reports =
  BACKEND + "/api/store_info/get_saved_reports";
export const API_delete_saved_report =
  BACKEND + "/api/store_info/delete_saved_report";
export const API_update_saved_reports_order =
  BACKEND + "/api/store_info/update_saved_reports_order";
export const API_update_saved_report_tab =
  BACKEND + "/api/store_info/update_saved_report_tab";
export const API_get_report_tabs =
  BACKEND + "/api/store_info/get_report_tabs";
export const API_create_report_tab =
  BACKEND + "/api/store_info/create_report_tab";
export const API_update_report_tab =
  BACKEND + "/api/store_info/update_report_tab";
export const API_delete_report_tab =
  BACKEND + "/api/store_info/delete_report_tab";
export const API_update_report_tabs_order =
  BACKEND + "/api/store_info/update_report_tabs_order";

// Employee Metrics APIs
export const API_calculate_employee_metric =
  BACKEND + "/api/user_info/calculate_employee_metric";
export const API_get_employee_metrics =
  BACKEND + "/api/user_info/get_employee_metrics";

// Summary Card Preferences
export const API_get_summary_card_preferences =
  BACKEND + "/api/user_info/get_summary_card_preferences";
export const API_save_summary_card_preferences =
  BACKEND + "/api/user_info/save_summary_card_preferences";

// AI Reporting
export const API_ai_reporting_chat_stream =
  BACKEND + "/api/store_info/ai_reporting_chat_stream";
export const API_get_assistant_question_report =
  BACKEND + "/api/store_info/get_assistant_question_report";
export const API_update_assistant_interaction_feedback =
  BACKEND + "/api/store_info/update_assistant_interaction_feedback";

// Operations Assistant
export const API_ops_assistant_chat_stream =
  BACKEND + "/api/store_info/ops_assistant_chat_stream";
export const API_ops_assistant_confirm_action =
  BACKEND + "/api/store_info/ops_assistant_confirm_action";
export const API_ops_assistant_bulk_confirm =
  BACKEND + "/api/store_info/ops_assistant_bulk_confirm";
export const API_setup_assistant_chat_stream =
  BACKEND + "/api/store_info/setup_assistant_chat_stream";
export const API_setup_assistant_confirm_action =
  BACKEND + "/api/store_info/setup_assistant_confirm_action";
export const API_setup_assistant_bulk_confirm =
  BACKEND + "/api/store_info/setup_assistant_bulk_confirm";
export const API_setup_assistant_upload_roster =
  BACKEND + "/api/store_info/setup_assistant_upload_roster";
export const API_ops_assistant_transcribe_voice =
  BACKEND + "/api/store_info/ops_assistant_transcribe_voice";

// Operations Assistant shortcut chips (per-user)
export const API_ops_assistant_shortcuts =
  BACKEND + "/api/store_info/ops_assistant_shortcuts";
export const API_create_ops_assistant_shortcut =
  BACKEND + "/api/store_info/ops_assistant_shortcuts/create";
export const API_update_ops_assistant_shortcut = (id) =>
  BACKEND + `/api/store_info/ops_assistant_shortcuts/${id}`;
export const API_delete_ops_assistant_shortcut = (id) =>
  BACKEND + `/api/store_info/ops_assistant_shortcuts/${id}/delete`;
export const API_reorder_ops_assistant_shortcuts =
  BACKEND + "/api/store_info/ops_assistant_shortcuts/reorder";
export const API_ops_assistant_shortcut_templates =
  BACKEND + "/api/store_info/ops_assistant_shortcut_templates";

export const API_update_notification_settings =
  BACKEND + "/api/notification_info/update_settings";

export const API_store_team_member_set_hide =
  BACKEND + "/api/user_info/store_team_member_set_hide";

export const API_store_team_member_set_order =
  BACKEND + "/api/user_info/store_team_member_set_order";

export const API_role_set_order = BACKEND + "/api/role_set_order";

export const API_get_hours_for_all_stores =
  BACKEND + "/api/store_info/get_hours_for_all_stores";

export const API_update_hours_for_all_stores =
  BACKEND + "/api/store_info/update_hours_for_all_stores";

// Logbook

export const API_get_logbook_columns =
  BACKEND + "/api/logbook_info/get_logbook_columns";

export const API_post_logbook_category =
  BACKEND + "/api/logbook_info/post_logbook_category";

export const API_delete_logbook_category =
  BACKEND + "/api/logbook_info/delete_logbook_category";

export const API_post_reorder_logbook_columns_and_categories =
  BACKEND + "/api/logbook_info/post_reorder_logbook_columns_and_categories";

export const API_get_logbook_category_templates =
  BACKEND + "/api/logbook_info/get_logbook_category_templates";

export const API_post_apply_logbook_category_template =
  BACKEND + "/api/logbook_info/post_apply_logbook_category_template";

export const API_get_logbook_category_entries =
  BACKEND + "/api/logbook_info/get_logbook_category_entries";

export const API_post_logbook_category_entry =
  BACKEND + "/api/logbook_info/post_logbook_category_entry";

export const API_delete_logbook_category_entry =
  BACKEND + "/api/logbook_info/delete_logbook_category_entry";

export const API_get_logbook_entries_report =
  BACKEND + "/api/logbook_info/get_logbook_entries_report";

export const API_get_logbook_entry_authors =
  BACKEND + "/api/logbook_info/get_logbook_entry_authors";

export const API_get_logbook_page =
  BACKEND + "/api/logbook_info/get_logbook_page";

export const API_post_logbook_layout =
  BACKEND + "/api/logbook_info/post_logbook_layout";

export const API_get_logbook_layout =
  BACKEND + "/api/logbook_info/get_logbook_layout";

export const API_get_logbook_metric_sources =
  BACKEND + "/api/logbook_info/get_logbook_metric_sources";

export const API_get_logbook_notify_users =
  BACKEND + "/api/logbook_info/get_logbook_notify_users";

export const API_post_logbook_block_entry =
  BACKEND + "/api/logbook_info/post_logbook_block_entry";

export const API_delete_logbook_block_entry =
  BACKEND + "/api/logbook_info/delete_logbook_block_entry";

export const API_get_logbook_ask =
  BACKEND + "/api/logbook_info/get_logbook_ask";

export const API_get_logbook_agents =
  BACKEND + "/api/logbook_info/get_logbook_agents";

export const API_post_logbook_agent =
  BACKEND + "/api/logbook_info/post_logbook_agent";

export const API_delete_logbook_agent =
  BACKEND + "/api/logbook_info/delete_logbook_agent";

export const API_post_run_logbook_agent =
  BACKEND + "/api/logbook_info/post_run_logbook_agent";

export const API_get_logbook_email_preview =
  BACKEND + "/api/logbook_info/get_logbook_email_preview";

export const API_get_logbook_templates =
  BACKEND + "/api/logbook_info/get_logbook_templates";

export const API_post_apply_logbook_template =
  BACKEND + "/api/logbook_info/post_apply_logbook_template";

// Employee Notes

export const API_get_logbook_employee_entries =
  BACKEND + "/api/logbook_info/get_logbook_employee_entries";

export const API_post_logbook_employee_entry =
  BACKEND + "/api/logbook_info/post_logbook_employee_entry";

export const API_delete_logbook_employee_entry =
  BACKEND + "/api/logbook_info/delete_logbook_employee_entry";

// Check-Ins

export const API_get_check_in_template =
  BACKEND + "/api/check_in_info/get_check_in_template";
export const API_create_check_in_template =
  BACKEND + "/api/check_in_info/create_check_in_template";
export const API_update_check_in_template =
  BACKEND + "/api/check_in_info/update_check_in_template";
export const API_use_default_check_in_template =
  BACKEND + "/api/check_in_info/use_default_check_in_template";
export const API_create_check_in_template_section =
  BACKEND + "/api/check_in_info/create_check_in_template_section";
export const API_update_check_in_template_section =
  BACKEND + "/api/check_in_info/update_check_in_template_section";
export const API_delete_check_in_template_section =
  BACKEND + "/api/check_in_info/delete_check_in_template_section";
export const API_reorder_check_in_template_sections =
  BACKEND + "/api/check_in_info/reorder_check_in_template_sections";
export const API_create_check_in_template_field =
  BACKEND + "/api/check_in_info/create_check_in_template_field";
export const API_update_check_in_template_field =
  BACKEND + "/api/check_in_info/update_check_in_template_field";
export const API_delete_check_in_template_field =
  BACKEND + "/api/check_in_info/delete_check_in_template_field";
export const API_reorder_check_in_template_fields =
  BACKEND + "/api/check_in_info/reorder_check_in_template_fields";
export const API_create_check_in =
  BACKEND + "/api/check_in_info/create_check_in";
export const API_get_check_in =
  BACKEND + "/api/check_in_info/get_check_in";
export const API_get_check_ins_for_employee =
  BACKEND + "/api/check_in_info/get_check_ins_for_employee";
export const API_update_check_in =
  BACKEND + "/api/check_in_info/update_check_in";
export const API_update_check_in_responses =
  BACKEND + "/api/check_in_info/update_check_in_responses";
export const API_delete_check_in =
  BACKEND + "/api/check_in_info/delete_check_in";
export const API_create_check_in_action_item =
  BACKEND + "/api/check_in_info/create_check_in_action_item";
export const API_update_check_in_action_item =
  BACKEND + "/api/check_in_info/update_check_in_action_item";
export const API_toggle_check_in_action_item =
  BACKEND + "/api/check_in_info/toggle_check_in_action_item";
export const API_delete_check_in_action_item =
  BACKEND + "/api/check_in_info/delete_check_in_action_item";
export const API_get_check_in_scale_history =
  BACKEND + "/api/check_in_info/get_check_in_scale_history";
export const API_get_my_check_ins =
  BACKEND + "/api/check_in_info/get_my_check_ins";

// Maintenance

export const API_get_maintenance_requests =
  BACKEND + "/api/maintenance_info/get_maintenance_requests";

export const API_post_maintenance_request =
  BACKEND + "/api/maintenance_info/post_maintenance_request";

export const API_update_maintenance_request =
  BACKEND + "/api/maintenance_info/update_maintenance_request";

export const API_delete_maintenance_request =
  BACKEND + "/api/maintenance_info/delete_maintenance_request";

export const API_get_store_employees_for_assignment =
  BACKEND + "/api/maintenance_info/get_store_employees_for_assignment";

export const API_get_recurring_maintenance_templates =
  BACKEND + "/api/maintenance_info/get_recurring_maintenance_templates";

export const API_post_recurring_maintenance_template =
  BACKEND + "/api/maintenance_info/post_recurring_maintenance_template";

export const API_update_recurring_maintenance_template =
  BACKEND + "/api/maintenance_info/update_recurring_maintenance_template";

export const API_delete_recurring_maintenance_template =
  BACKEND + "/api/maintenance_info/delete_recurring_maintenance_template";

export const API_get_maintenance_comments =
  BACKEND + "/api/maintenance_info/get_maintenance_comments";

export const API_post_maintenance_comment =
  BACKEND + "/api/maintenance_info/post_maintenance_comment";

export const API_get_maintenance_timeline =
  BACKEND + "/api/maintenance_info/get_maintenance_timeline";

export const API_get_ticket_issue_types =
  BACKEND + "/api/maintenance_info/get_ticket_issue_types";

export const API_get_assignment_settings =
  BACKEND + "/api/maintenance_info/get_assignment_settings";

export const API_update_assignment_settings =
  BACKEND + "/api/maintenance_info/update_assignment_settings";

export const API_decide_maintenance_request_approval =
  BACKEND + "/api/maintenance_info/decide_maintenance_request_approval";

export const API_get_maintenance_assets =
  BACKEND + "/api/maintenance_info/get_maintenance_assets";

export const API_get_maintenance_asset =
  BACKEND + "/api/maintenance_info/get_maintenance_asset";

export const API_get_maintenance_asset_suggestions =
  BACKEND + "/api/maintenance_info/get_maintenance_asset_suggestions";

export const API_post_maintenance_asset =
  BACKEND + "/api/maintenance_info/post_maintenance_asset";

export const API_update_maintenance_asset =
  BACKEND + "/api/maintenance_info/update_maintenance_asset";

export const API_archive_maintenance_asset =
  BACKEND + "/api/maintenance_info/archive_maintenance_asset";

export const API_import_maintenance_assets_csv =
  BACKEND + "/api/maintenance_info/import_maintenance_assets_csv";

// Printed on asset stickers. The mobile app claims /asset/* on this domain,
// so a QR of this link opens the app straight to a new ticket. Printed
// stickers can't change, so this must stay the production web domain.
export const ASSET_STICKER_LINK_BASE = "https://getrightwork.dev/asset/";

// Boards (kanban)

export const API_get_board = BACKEND + "/api/board_info/get_board";

export const API_get_board_members =
  BACKEND + "/api/board_info/get_board_members";

export const API_create_board_list =
  BACKEND + "/api/board_info/create_board_list";

export const API_update_board_list =
  BACKEND + "/api/board_info/update_board_list";

export const API_move_board_list =
  BACKEND + "/api/board_info/move_board_list";

export const API_archive_board_list =
  BACKEND + "/api/board_info/archive_board_list";

export const API_create_board_card =
  BACKEND + "/api/board_info/create_board_card";

export const API_update_board_card =
  BACKEND + "/api/board_info/update_board_card";

export const API_move_board_card =
  BACKEND + "/api/board_info/move_board_card";

export const API_archive_board_card =
  BACKEND + "/api/board_info/archive_board_card";

export const API_duplicate_board_card =
  BACKEND + "/api/board_info/duplicate_board_card";

export const API_set_card_label = BACKEND + "/api/board_info/set_card_label";

export const API_set_card_member = BACKEND + "/api/board_info/set_card_member";

export const API_attach_board_card_file =
  BACKEND + "/api/board_info/attach_board_card_file";

export const API_remove_board_card_file =
  BACKEND + "/api/board_info/remove_board_card_file";

export const API_create_board_label =
  BACKEND + "/api/board_info/create_board_label";

export const API_update_board_label =
  BACKEND + "/api/board_info/update_board_label";

export const API_delete_board_label =
  BACKEND + "/api/board_info/delete_board_label";

export const API_get_board_card_comments =
  BACKEND + "/api/board_info/get_board_card_comments";

export const API_post_board_card_comment =
  BACKEND + "/api/board_info/post_board_card_comment";

export const API_create_board_checklist =
  BACKEND + "/api/board_info/create_board_checklist";

export const API_update_board_checklist =
  BACKEND + "/api/board_info/update_board_checklist";

export const API_delete_board_checklist =
  BACKEND + "/api/board_info/delete_board_checklist";

export const API_create_board_checklist_item =
  BACKEND + "/api/board_info/create_board_checklist_item";

export const API_update_board_checklist_item =
  BACKEND + "/api/board_info/update_board_checklist_item";

export const API_delete_board_checklist_item =
  BACKEND + "/api/board_info/delete_board_checklist_item";

// Daily plan

export const API_get_plan_tasks = BACKEND + "/api/plan_info/get_plan_tasks";

export const API_get_plan_task_templates =
  BACKEND + "/api/plan_info/get_plan_task_templates";

export const API_import_plan_task_templates =
  BACKEND + "/api/plan_info/import_plan_task_templates";

export const API_post_plan_task = BACKEND + "/api/plan_info/post_plan_task";

export const API_set_plan_task_status =
  BACKEND + "/api/plan_info/set_plan_task_status";

export const API_delete_plan_task = BACKEND + "/api/plan_info/delete_plan_task";

export const API_get_plan_tasks_for_date =
  BACKEND + "/api/plan_info/get_plan_tasks_for_date";

export const API_get_plan_task_analytics =
  BACKEND + "/api/plan_info/get_plan_task_analytics";

export const API_get_plan_task_analytics_overview =
  BACKEND + "/api/plan_info/get_plan_task_analytics_overview";

export const API_assign_plan_task = BACKEND + "/api/plan_info/assign_plan_task";

export const API_get_plan_tasks_for_user_and_date =
  BACKEND + "/api/plan_info/get_plan_tasks_for_user_and_date";

export const API_save_plan_task_assignment =
  BACKEND + "/api/plan_info/save_plan_task_assignment";

export const API_save_plan_task_assignment_kiosk =
  BACKEND + "/api/plan_info/save_plan_task_assignment_kiosk";

export const API_get_now_tasks = BACKEND + "/api/plan_info/get_now_tasks";

export const API_get_now_tasks_kiosk =
  BACKEND + "/api/plan_info/get_now_tasks_kiosk";

export const API_get_plan_task_overview =
  BACKEND + "/api/plan_info/get_plan_task_overview";

export const API_start_plan_task_assignment =
  BACKEND + "/api/plan_info/start_plan_task_assignment";

export const API_start_plan_task_assignment_kiosk =
  BACKEND + "/api/plan_info/start_plan_task_assignment_kiosk";

export const API_pause_plan_task_assignment_kiosk =
  BACKEND + "/api/plan_info/pause_plan_task_assignment_kiosk";

export const API_validate_plan_task_assignment =
  BACKEND + "/api/plan_info/validate_plan_task_assignment";

export const API_pause_plan_task_assignment =
  BACKEND + "/api/plan_info/pause_plan_task_assignment";

export const API_resume_plan_task_assignment =
  BACKEND + "/api/plan_info/resume_plan_task_assignment";
export const API_get_plan_task_comments =
  BACKEND + "/api/plan_info/get_plan_task_comments";
export const API_post_plan_task_comment =
  BACKEND + "/api/plan_info/post_plan_task_comment";
export const API_get_plan_task_comments_kiosk =
  BACKEND + "/api/plan_info/get_plan_task_comments_kiosk";
export const API_post_plan_task_comment_kiosk =
  BACKEND + "/api/plan_info/post_plan_task_comment_kiosk";
export const API_get_plan_task_timeline =
  BACKEND + "/api/plan_info/get_plan_task_timeline";
export const API_create_plan_task_follow_up =
  BACKEND + "/api/plan_info/create_plan_task_follow_up";
export const API_link_plan_task_follow_up =
  BACKEND + "/api/plan_info/link_plan_task_follow_up";
export const API_get_plan_task_follow_ups =
  BACKEND + "/api/plan_info/get_plan_task_follow_ups";


// Copilot

export const API_get_copilot_schedule =
  BACKEND + "/api/store_info/get_copilot_schedule?store_id=";

export const API_get_copilot_status =
  BACKEND + "/api/store_info/get_copilot_status?store_id=";

// Documents

export const API_get_documents =
  BACKEND + "/api/file_upload_info/get_documents";

export const API_create_folder =
  BACKEND + "/api/file_upload_info/create_folder";

export const API_rename_folder =
  BACKEND + "/api/file_upload_info/rename_folder";

export const API_move_folder = BACKEND + "/api/file_upload_info/move_folder";

export const API_delete_folder =
  BACKEND + "/api/file_upload_info/delete_folder";

export const API_toggle_folder_assistant_searchable =
  BACKEND + "/api/file_upload_info/toggle_folder_assistant_searchable";

export const API_set_folder_permission_level =
  BACKEND + "/api/file_upload_info/set_folder_permission_level";

export const API_rename_file = BACKEND + "/api/file_upload_info/rename_file";

export const API_move_file = BACKEND + "/api/file_upload_info/move_file";

// Schedule Insights

export const API_get_weekly_schedule_insight =
  BACKEND + "/api/store_info/get_weekly_schedule_insight";

// Analytics / tracking
export const API_analytics_create_event =
  BACKEND + "/api/analytics_info/create_event/";

export const API_post_store_copilot_feedback =
  BACKEND + "/api/store_info/post_store_feedback";

// AI Assistant
export const API_get_file_system_insights =
  BACKEND + "/api/file_upload_info/get_file_system_insights";
export const API_get_file_system_insights_stream =
  BACKEND + "/api/file_upload_info/get_file_system_insights_stream";
export const API_create_voice_session =
  BACKEND + "/api/file_upload_info/create_voice_session";
export const API_log_voice_assistant_interaction =
  BACKEND + "/api/file_upload_info/log_voice_assistant_interaction";
export const API_voice_rag_search =
  BACKEND + "/api/file_upload_info/voice_rag_search";

// Badge Counts
export const API_get_badge_counts = BACKEND + "/api/user_info/get_badge_counts"

// Company Creation
export const API_create_company = BACKEND + "/api/company_info/create_company"
export const API_load_sandbox_data = BACKEND + "/api/company_info/load_sandbox_data"

// POS Integration
export const API_integrate_pos_toast = BACKEND + "/api/company_info/integrate_pos_toast"

// Labor Laws

export const API_list_labor_laws_for_company = BACKEND + "/api/labor_law_info/list_labor_laws_for_company"
export const API_set_labor_law_hidden_for_store = BACKEND + "/api/labor_law_info/set_labor_law_hidden_for_store"
export const API_get_compliance_audit = BACKEND + "/api/labor_law_info/get_compliance_audit"

// Jurisdictions

export const API_list_jurisdictions = BACKEND + "/api/jurisdiction_info/list_jurisdictions"
export const API_update_store_jurisdictions = BACKEND + "/api/jurisdiction_info/update_store_jurisdictions"

export const FEATURE_FLAGS = [
  "mobile_app_enabled",
  "scheduling_enabled",
  "time_entries_enabled",
  "time_entries_on_mobile_enabled",
  "time_entries_role_selection_enabled",
  "time_entries_auto_approval_enabled",
  "time_entries_hours_rounded_to_tenths_enabled",
  "payroll_enabled",
  "payroll_wages_enabled",
  "payroll_employee_review_enabled",
  "training_enabled",
  "proficiency_from_lms_enabled",
  "engagement_enabled",
  "logbook_enabled",
  "daily_plan_enabled",
  "copilot_enabled",
  "forecasting_enabled",
  "manual_sales_input_enabled",
  "labor_recap_emails_enabled",
  "labor_law_enabled",
  "labor_model_enabled",
  "contests_enabled",
  "assistant_enabled",
  "chat_enabled",
  "daily_working_chats_enabled",
  "employee_create_chat_enabled",
  "manager_create_chat_enabled",
  "store_admins_in_store_chat_enabled",
  "labor_percent_enabled",
  "tplh_enabled",
  "break_waiver_enabled",
  "edit_shifts_in_past_enabled",
  "lock_forecast_on_publish_enabled",
  "publish_schedule_review_required_enabled",
  "block_publish_on_labor_violations_enabled",
  "default_daily_card_chart_enabled",
  "minimized_view_default_enabled",
  "documents_enabled",
  "print_hours_shown_enabled",
  "paid_break_inputs_enabled",
  "breaks_shown_to_employee_enabled",
  "deployment_enabled",
  "maintenance_enabled",
  "it_tickets_enabled",
  "marketing_tickets_enabled",
  "menu_tickets_enabled",
];

export const API_retry_onboarding_backfills = BACKEND + "/api/company_info/retry_onboarding_backfills";

export const API_preview_data_preparation = BACKEND + "/api/company_info/preview_data_preparation";

export const API_google_hours_audit = BACKEND + "/api/store_info/google_hours_audit";

export const API_update_internal_company_deletion_request =
  BACKEND + "/api/billing_info/update_internal_company_deletion_request";

export const API_get_internal_company_details = BACKEND + "/api/billing_info/get_internal_company_details";

export const API_get_internal_company_deletion_preview = BACKEND + "/api/billing_info/get_internal_company_deletion_preview";

export const API_approve_internal_company_deletion = BACKEND + "/api/billing_info/approve_internal_company_deletion";

export const API_update_internal_company_deletion_job = BACKEND + "/api/billing_info/update_internal_company_deletion_job";

export const API_refresh_internal_company_payment_health = BACKEND + "/api/billing_info/refresh_internal_company_payment_health";
export const API_internal_payment_reminder = BACKEND + "/api/billing_info/internal_payment_reminder";

export const API_get_forecast_accuracy = BACKEND + "/api/store_info/forecast_accuracy";
